import { BaseState } from '@/store/base-state';
import { CoursesRequests } from '@/modules/courses-requests/types';
import { EditableCoursesRequest } from '@/modules/courses-requests/store/modules/editable/types';
import { default_courses } from '@/modules/courses-requests/store/modules/editable/services';

export default class EditableCoursesRequestState extends BaseState {
  loading = false;
  request_id: number | null = 0;
  organization_id: number | null = null;
  type: EditableCoursesRequest.CoursesTypes | null = null;
  send = false;
  edited = false;

  selected_courses: EditableCoursesRequest.Course[] = [];

  original_courses: CoursesRequests.Course[] = [];
  editable_courses: CoursesRequests.Course[] = [];

  selected_staffs: EditableCoursesRequest.Staff[] = [];

  original_staffs: CoursesRequests.Staff[] = [];
  editable_staffs: CoursesRequests.Staff[] = [];

  filters: CoursesRequests.StaffsFilters = {
    courses_ids: [],
    staffs_ids: [],
  };

  original_staffs_filter_by_staffs: CoursesRequests.StaffsTableFilter[] = [];
  editable_staffs_filter_by_staffs: CoursesRequests.StaffsTableFilter[] = [];
  original_staffs_filter_by_courses: CoursesRequests.StaffsTableFilter[] = [];
  editable_staffs_filter_by_courses: CoursesRequests.StaffsTableFilter[] = [];

  // Dialog

  selection_lists_loading = false;

  courses: EditableCoursesRequest.Courses = default_courses();

  staffs: EditableCoursesRequest.Staff[] = [];
}
